<div class="card" [style.background]="backgroundStyle">
  <div class="main-container">
    <ng-container *ngFor="let contact of tileInstance.contacts; let last = last">
      <div class="person-container d-flex fd-row fd-col--sm jc-center">
        <div
          class="image-container d-flex ai-center jc-center--lt-md"
          style="flex: 0 0 250px"
          [ngClass]="contact.imgPosition === 'start' ? 'jc-start' : 'jc-end'"
          [style.order]="contact.imgPosition === 'start' ? '0' : '1'"
        >
          <div class="image-circle">
            <img class="image" [src]="getContactImgPath(contact.img)" />
          </div>
        </div>
        <div
          class="text-container d-flex fd-col jc-center ai-center--lt-md"
          style="flex: 0 0 70%"
        >
          <div class="name-container d-flex fd-col jc-center ai-center--lt-md">
            <span
              class="name"
              [style.color]="contact.fullNameFontColor"
              [style.fontSize]="contact.fullNameFontSize | pxSuffix"
            >
              {{ contact.fullName }}
            </span>
            <span
              class="title"
              [style.color]="contact.roleFontColor"
              [style.fontSize]="contact.roleFontSize | pxSuffix"
            >
              {{ contact.role }}
            </span>
          </div>
          <div class="about-container">
            <p
              class="about"
              [style.color]="contact.textFontColor"
              [style.fontSize]="contact.textFontSize | pxSuffix"
            >
              {{ contact.text }}
            </p>
          </div>
          <div class="contact-container d-flex fd-row">
            <div *ngIf="contact.phone" class="phone-number-container">
              <mat-icon class="contact-icon">phone</mat-icon>
              <a class="tel" [href]="'tel:' + contact.phone">
                {{ contact.phone }}
              </a>
            </div>
            <div class="email-container">
              <mat-icon class="contact-icon">email</mat-icon>
              <a class="email" [href]="'mailto:' + contact.email">
                {{ contact.email }}
              </a>
            </div>
          </div>
          <mat-divider *ngIf="!last" class="divider"></mat-divider>
        </div>
      </div>
    </ng-container>
  </div>
</div>
